export const GET_ACCOUNT_LIST = "account/GET_ACCOUNT_LIST";
export const SET_ACCOUNT_LIST = "account/SET_ACCOUNT_LIST";
export const CLEAR_ACCOUNT_LIST = "account/CLEAR_ACCOUNT_LIST";
